import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import { cn } from '@utils/cn';

interface PageHeaderProps {
  title: string;
  /** Optional subtitle line under the title */
  subtitle?: string;
  /** Optional icon shown next to the title (typically a Material UI icon) */
  icon?: React.ReactNode;
  /** When provided, renders a back arrow that links to this path */
  backTo?: string;
  /** Right-aligned slot for action buttons */
  actions?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  icon,
  backTo,
  actions,
  className,
}) => (
  <div className={cn('flex justify-between items-center', className)}>
    <div className="flex items-center gap-3">
      {backTo && (
        <Link
          to={backTo}
          className="text-gray-500 hover:text-gray-700"
          title="Back"
        >
          <ArrowBackIcon sx={{ fontSize: 22 }} />
        </Link>
      )}
      {icon && (
        <span className="text-orange-400 dark:text-orange-300 inline-flex items-center">
          {icon}
        </span>
      )}
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
        {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
